import {Routes} from '@angular/router';
import {AuthGuard} from '@core/services/auth-guard.service';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';

export const procedurePublisherRoutes: Routes = [
  {
    path     : 'tax-form-publisher',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path     : 'procedure-publisher',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path     : 'publications/duedatetracker',
    component: PlatformLinkCreatorComponent,
  },
  {
    path     : 'publications/change-report-tracker',
    component: PlatformLinkCreatorComponent,
  },
  {
    path     : 'publications/change-report-tracker/:publicationId',
    component: PlatformLinkCreatorComponent,
  },
  {
    path     : 'publications/duedatetracker/:publicationId',
    component: PlatformLinkCreatorComponent,
  }
];


